"use client";
import { format } from "date-fns";
import htmr from "htmr";
import { useEffect, useState } from "react";
import { StyleSheet } from "react-native";

import { useAuth, useContentResource } from "@ctv/core";
import {
  Divider,
  DotLoader,
  formatMessage,
  Text,
  Token,
  useLocalizedRouterServer,
  useQueryString,
  View,
} from "@ctv/shared-core/src";
import BlankHeader from "@ctv/shared/components/Layout/BlankHeader";

import SectionsRenderer from "./_components/SectionsRenderer";
import { termsAndConditionsStyles } from "./styles";

type Props = {
  verified: boolean;
};

export default function TermsAndConditions(props: Props) {
  const { verified } = props;
  const [loadPage, setLoadPage] = useState(false);

  const cr = useContentResource().CorporateTermsAndConditions;
  const { isAuthenticated } = useAuth();
  const router = useLocalizedRouterServer();
  const qs = useQueryString("object");

  useEffect(() => {
    // Shallow routing, to remove the query string `key=` from the URL
    router.shallow("/terms-and-conditions", "replace");
    if (isAuthenticated || verified) {
      setLoadPage(true);
      return;
    }

    const locationHistory = JSON.parse(
      window.localStorage.getItem("lh") ?? "[]"
    );

    const fromVerifyPage =
      preprocessPath(locationHistory[0].path) ===
      "/terms-and-conditions/verify/";
    if (!locationHistory[0] || !fromVerifyPage || !qs.key) {
      router.push("/terms-and-conditions/verify");
    } else if (fromVerifyPage && !verified) {
      router.push("/terms-and-conditions/verify?error=true");
    }
  }, []);

  if (!loadPage) {
    return (
      <View flex justify="center" align="center">
        <DotLoader />
      </View>
    );
  }

  return (
    <View flex>
      <BlankHeader />
      <View style={styles.wrapper} spacing="m" gapSpacing>
        <Text variant="title-1">{cr.title}</Text>
        <Divider />
        <Text variant="ui-small">{cr.lastUpdatedText}</Text>
        <Text style={termsAndConditionsStyles.justify} variant="ui-small">
          {htmr(cr.body)}
        </Text>
        <Divider />
        <SectionsRenderer />
        <View style={styles.footer} spacing="xxxl">
          <Divider />
          <Text align="center" ink="black-secondary" variant="ui-small">
            © 2025 Traveloka
          </Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginHorizontal: "auto",
    paddingHorizontal: Token.spacing.xl,
    paddingVertical: Token.spacing.l,
    maxWidth: 768,
    minWidth: 320,
  },
  footer: {
    height: 100,
  },
  passwordCard: {
    width: 400,
    padding: Token.spacing.m,
    marginTop: Token.spacing.m,
    marginHorizontal: "auto",
  },
});

function preprocessPath(path: string): string {
  return (path.replace(/^\/[a-z]{2}-[a-z]{2}/, "") + "/").replaceAll("//", "/");
}
